import React from 'react';
import { Shield, Lock } from 'lucide-react';

const LOGO_URL = `${process.env.PUBLIC_URL}/logo.png`;

export const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          {/* Brand & Description */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Physiomobile" 
                className="h-8 w-auto"
              />
            </div>
            <p className="text-muted-foreground text-sm max-w-sm">
              Tech-enabled healthcare platform improving accessibility and outcomes in rehabilitation, physiotherapy, and recovery services.
            </p>
          </div>
          
          {/* Trust & Compliance */}
          <div className="md:text-right">
            <h4 className="font-semibold text-foreground mb-3">Trust & Security</h4>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2 md:justify-end text-sm text-muted-foreground">
                <Shield className="h-4 w-4 text-success" />
                <span>Investor Data Protected</span>
              </div>
              <div className="flex items-center gap-2 md:justify-end text-sm text-muted-foreground">
                <Lock className="h-4 w-4 text-primary" />
                <span>Confidential Information Handling</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Disclaimers */}
        <div className="border-t border-border pt-8 space-y-4">
          {/* Legal Disclaimer */}
          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-xs text-muted-foreground leading-relaxed">
              <strong className="text-foreground">Disclaimer:</strong> This dashboard is for indicative purposes only and does not constitute an offer to sell or a solicitation to buy securities. Pledges submitted through this platform are non-binding expressions of interest. Final investment terms, documentation, and legal agreements will be shared separately and are subject to regulatory compliance and due diligence processes.
            </p>
          </div>
          
          {/* Privacy Notice */}
          <div className="bg-muted/50 rounded-lg p-4">
            <p className="text-xs text-muted-foreground leading-relaxed">
              <strong className="text-foreground">Privacy Notice:</strong> All investor information submitted through this platform is kept strictly confidential and used solely for fundraising coordination by Physiomobile. Your data will not be shared with third parties without your explicit consent and will be handled in accordance with applicable data protection regulations.
            </p>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-4 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Physiomobile. All rights reserved.</p>
          <p>Pre-Series A Investment Round</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
